var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible"
        }
      ],
      staticClass: "drop-uploader-wrapper"
    },
    [
      _c(
        "el-upload",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.uploaderVisible,
              expression: "uploaderVisible"
            }
          ],
          ref: "uploader",
          staticClass: "drop-uploader",
          attrs: {
            no: "upload",
            drag: _vm.openDrag,
            multiple: _vm.multiple,
            "auto-upload": _vm.autoUpload,
            action: _vm.action,
            headers: _vm.headers,
            data: _vm.uploadParams,
            "file-list": _vm.fileList,
            "show-file-list": false,
            "before-upload": _vm.handleBeforeUpload,
            "on-progress": _vm.handleProgress,
            "on-success": _vm.handleSuccess,
            "on-error": _vm.handleError,
            accept: _vm.fileAccept,
            "on-change": _vm.toChooseFile
          }
        },
        [
          _vm.openDrag
            ? _c("div", { staticClass: "drop-uploader-icon" }, [
                _c("i", { staticClass: "el-icon-upload" }),
                _c("p", [_vm._v(_vm._s(_vm.$t("Message.AboutToUploadFiles")))])
              ])
            : _vm._e()
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.resultDialogVisible,
            title: _vm.$t("SeaExport.FileUpload"),
            width: "800px",
            "close-on-click-modal": _vm.closeOnClickModal
          },
          on: { close: _vm.resultDialogClose }
        },
        [
          _c("p", { staticStyle: { "text-align": "right", margin: "0" } }, [
            _vm._v(
              _vm._s(_vm.$t("CargoMsg.Cargo_AllAmount")) +
                "：" +
                _vm._s(_vm.total) +
                _vm._s(_vm.$t("CargoMsg.Cargo_Pcs")) +
                "，"
            ),
            _c("span", { staticStyle: { color: "green" } }, [
              _vm._v(
                _vm._s(_vm.$t("Message.SuccessfullyUploaded")) +
                  "：" +
                  _vm._s(_vm.success) +
                  _vm._s(_vm.$t("CargoMsg.Cargo_Pcs"))
              )
            ]),
            _vm._v("，"),
            _c("span", { staticStyle: { color: "red" } }, [
              _vm._v(
                _vm._s(_vm.$t("Message.Failure")) +
                  "：" +
                  _vm._s(_vm.fail) +
                  "个"
              )
            ])
          ]),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.fileList, "max-height": "400px" }
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "name",
                  label: _vm.$t("FileHistory.fileName"),
                  width: "180",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "raw.type",
                  label: _vm.$t("FileHistory.jobType"),
                  width: "180",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "size",
                  label: _vm.$t("FileHistory.fileSize"),
                  width: "180",
                  align: "center",
                  formatter: function(row, column, cellValue, index) {
                    return _vm.$numeral(cellValue / 1024).format("0.00") + "KB"
                  }
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "status",
                  label: _vm.$t("Message.UploadResults"),
                  width: "180",
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.status === "success"
                          ? _c("span", { staticStyle: { color: "green" } }, [
                              _vm._v(_vm._s(_vm.$t("queryJob.uploadSucceeded")))
                            ])
                          : scope.row.status === "fail"
                          ? _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v(_vm._s(_vm.$t("queryJob.uploadFailed")))
                            ])
                          : _c("span", { staticStyle: { color: "#1890ff" } }, [
                              _c("i", { staticClass: "el-icon-loading" }),
                              _vm._v(_vm._s(_vm.$t("queryJob.uploading")))
                            ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }